import { equals, map } from 'ramda';
import React from 'react';
import { availableChartRanges, ChartRange } from '../../entities';
import Interval from './Interval';

interface Props {
  changeRange: (range: ChartRange) => void;
  range: ChartRange;
}

const Intervals = ({ changeRange, range }: Props) => {
  const renderInterval = (chartRange: ChartRange) => {
    const currentRange = ChartRange[chartRange];
    const isActive = equals(currentRange, range);

    return <Interval changeRange={changeRange} isActive={isActive} key={chartRange} range={currentRange} />;
  };

  return <div>{map(renderInterval, availableChartRanges)}</div>;
};

export default Intervals;
